<template>
  <div class="page" :class="shop.banner_top==1?'special':''" v-wechat-title="$route.meta.title">
    <div class="link-btn" @click="goHome" v-if="res.ismain!='undefined'&&res.ismain==1 && !isWxMini">首页</div>
    <div class="link-btn link-back" @click="back" v-if="isback==1 && !isWxMini">返回</div>

    <!--关注-->
    <div class="focus" v-if="res.isfocushint==1&&(res.isfocus==0||res.isfocus==null)">
      <img class="icon-focus" :src="focusRes.isconfig==6?focusRes.focusimg:require('../../assets/icon-focus.png')" alt="">
      <span class="focus-txt hide">{{focusRes.isconfig==6?focusRes.focusinfo:'关注金牌解说&nbsp;&nbsp;收听更多景区讲解'}}</span>
      <span class="focus-btn" @click="focusFun()" v-if="focusRes.focusinfo && isNaN(parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,'')))">关注</span>
      <a class="focus-btn" :href="'tel:' + parseInt((focusRes.focusinfo).replace(/[^0-9]/ig,''))" v-else>拨号</a>
    </div>

    <!--轮播图-->
    <div class="swiper-con border-box" style="position: relative;">
      <img class="icon-share" src="../../assets/icon-share.png"  @click="showPoster" v-if="shopid!=1766" />
      <Swiper :banners="banners" :type="'view'"></Swiper>
    </div>

    <!--语音景区详情及目录地图切换-->
    <div class="tab-intro box border-box">
      <div @click="tabIntroCurr=1" class="flex tab-intro-btn01" :class="tabIntroCurr==1?'curr':''">
        <img class="scenic-icon" src="../../assets/scenic-icon1.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon1-curr.png" alt="">
        <span>语音讲解</span>
      </div>
      <div @click="tabIntroCurr=6" class="flex tab-intro-btn06" :class="tabIntroCurr==6?'curr':''" v-if="res.istour==1">
        <img class="scenic-icon" src="../../assets/scenic-icon6.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon6-curr.png" alt="">
        <span>讲解导览</span>
      </div>
      <div @click="tabIntroCurr=2" class="flex tab-intro-btn02" v-if="shopid!=1832" :class="tabIntroCurr==2?'curr':''">
        <img class="scenic-icon" src="../../assets/scenic-icon2.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon2-curr.png" alt="">
        <span>景区简介</span>
      </div>
      <div @click="catalogueCurr1" class="flex tab-intro-btn03">
        <img class="scenic-icon" src="../../assets/scenic-icon5.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon5-curr.png" alt="">
        <span>讲解点目录</span>
      </div>
      <a class="flex tab-intro-btn03" v-if="res.storeStatus==1" :href="res.storeUrl" target="_blank" style="display: block;">
        <img class="scenic-icon" src="../../assets/scenic-icon4.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon4-curr.png" alt="">
        <span>文创小店</span>
      </a>
      <div @click="toMap" class="flex tab-intro-btn04" v-if="res.isMap==1&&!isWxMini">
        <img class="scenic-icon" src="../../assets/scenic-icon3.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon5-curr.png" alt="">
        <span>地图导览</span>
      </div>

    </div>

    <!--语音列表-->
    <div class="voice-box" :class="tabIntroCurr==1?'':'none'">
      <!--我的已购-->
      <div class="popularity-recommend" v-if="mylist.length>0">
        <div class="popularity-recommend-title border-box">我的已购</div>
        <div class="list border-box">
          <div  v-for="(item,index) in mylist" :key="index">
            <div  class="list-box box" @click="goVideoPlay(index,'myList')">
              <!--左侧头像部分-->
              <div class="block list-img">
                <!--解说员头像-->
                <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
                <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
                <!--头像底部语音播放 -->
                <div class="listen-btn-num">
                  <img src="../../assets/icon-listen.png" alt="">
                  <span>收听</span>
                </div>
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <!--语音名称-->
                <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
                  <span v-if="item.guidetag">{{item.guidetag}}</span>
                </div>
                <div class="list-group hide">
                  <span class="fl hide">{{item.name}}</span>
                  <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
                </div>
                <!--标签-->
                <div class="mt6 clearfix">
                  <div v-if="item.listen>0" class="label-color">
                    <img src="../../assets/adot-5.png" alt="">
                    <span>{{item.listen|initNumber}}人收听</span>
                  </div>
                  <div v-if="(item.dsnum>0&&item.buynum<=0&&res.noReward!=1)" class="label-color">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.dsnum|initNumber}}人打赏</span>
                  </div>
                  <div v-else-if="(item.buynum>0&&item.price>0) && noBuys.indexOf(shopid)<=-1" class="label-color">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.buynum|initNumber1}}人购买</span>
                  </div>
                </div>
                <div class="sees-num-block clearfix">
                  <div class="label-color">
                    <img src="../../assets/adot-7.png" alt="">
                    <span>包含{{item.sees}}个讲解点</span>
                  </div>
                </div>
                <!--价格-->
                <div class="price-text-box clearfix">
                  <div v-if="item.price!=0" class="price-text">
                    <div>{{item.price}}元 <span class="sellprice" v-if="shop.showSellprice">{{item.price2}}元</span><span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
                  </div>
                  <div v-else-if="item.price==0" class="price-text">{{((shopid=='1823'||shopid=='1882')&&(item.label=='日语版'||item.label=='英文版'))?'Free':(res.noReward!=1?'打赏':'免费')}}</div>
                </div>
                <!--右侧购买收听按钮-->
                <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index,'myList')">详情</button>
                <button class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'myList')">收听</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--官方推荐-->
      <div class="popularity-recommend" v-if="tlist.length>0&&shopid!=1639">
        <div class="popularity-recommend-title border-box">官方推荐</div>
        <div class="list border-box">
          <div  v-for="(item,index) in tlist" :key="index">
            <div  class="list-box box list-boxVideo" @click="goVideoPlayView(index,'tjList')" v-if="item.bagtype==1">
              <!--左侧头像部分-->
              <div class="block list-img">
                <!--解说员头像-->
                <img class="icon-tx" v-lazy="item.tvideourl" alt="">
                <div class="listen-btn-num">
                  <img src="../../assets/icon_play_btn13.png" alt="">
                  <span  v-if="item.buy==12||item.price==0||item.isuser">观看</span>
                  <span  v-else>试看</span>
                </div>
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <!--语音名称-->
                <div class="list-name guide-name hide">{{item.name}}
                  <span v-if="item.label">{{item.label}}</span>
                </div>
                <div class="list-group hide">
                  <span class="fl hide">{{item.info}}</span>
                </div>
                <!--标签-->
                <div class="mt6 clearfix">
                  <div class="label-color">
                    <img src="../../assets/adot-5.png" alt="">
                    <span>1000+次播放</span>
                  </div>
                  <div  class="label-color" v-if="noBuys.indexOf(shopid)<=-1 && (item.buynum>0&&item.price>0)">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.buynum|initNumber1}}人购买</span>
                  </div>
                </div>
                <!--价格-->
                <div class="price-text-box clearfix">
                  <div v-if="item.price!=0" class="price-text">
                    <div>{{item.price}}元 <span class="sellprice" v-if="shop.showSellprice">{{item.price2}}元</span></div>
                  </div>
                  <div v-else class="price-text">
                    <div>免费 </div>
                  </div>
                </div>
                <!--右侧购买收听按钮-->
                <button v-if="(item.buy!=12)&&(!item.isuser)&&(item.price!=0) || (item.buy==12||item.isuser)" class="btn buy-btn buy-btn1" @click.stop="goVideoPlayView(index,'tjList')">详情</button>
                <button v-if="(item.buy==12)||(item.price==0)||(item.isuser)" class="btn buy-btn" @click.stop="goVideoPlayView(index,'tjList')">观看</button>
                <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo1(index,'tjList')">购买</button>
              </div>
            </div>
            <div  class="list-box box" @click="goVideoPlay(index,'tjList')" v-if="item.bagtype==null ||item.bagtype==0 ">
              <!--左侧头像部分-->
              <div class="block list-img">
                <!--解说员头像-->
                <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
                <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
                <!--头像底部语音播放 -->
                <div class="listen-btn-num" v-if="item.buy==12||item.price==0||item.isuser">
                  <img src="../../assets/icon-listen.png" alt="">
                  <span>收听</span>
                </div>
                <div class="listen-btn-num" @click.stop="listenTurlClick(index,'tjList')" v-else>
                  <img :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')" alt="">
                  <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
                </div>
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <!--语音名称-->
                <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
                  <span v-if="item.guidetag">{{item.guidetag}}</span>
                </div>
                <div class="list-group hide">
                  <span class="fl hide">{{item.name}}</span>
                  <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
                </div>
                <!--标签-->
                <div class="mt6 clearfix">
                  <div v-if="item.listen>0" class="label-color">
                    <img src="../../assets/adot-5.png" alt="">
                    <span>{{item.listen|initNumber}}人收听</span>
                  </div>
                  <div v-if="(item.dsnum>0&&item.buynum<=0&&res.noReward!=1)" class="label-color">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.dsnum|initNumber}}人打赏</span>
                  </div>
                  <div v-else-if="(item.buynum>0&&item.price>0) && noBuys.indexOf(shopid)<=-1" class="label-color">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.buynum|initNumber1}}人购买</span>
                  </div>
                </div>
                <div class="sees-num-block clearfix">
                  <div class="label-color">
                    <img src="../../assets/adot-7.png" alt="">
                    <span>包含{{item.sees}}个讲解点</span>
                  </div>
                </div>
                <!--价格-->
                <div class="price-text-box clearfix">
                  <div v-if="item.price!=0" class="price-text">
                    <div>{{item.price}}元 <span class="sellprice" v-if="shop.showSellprice">{{item.price2}}元</span><span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
                  </div>
                  <div v-else-if="item.price==0" class="price-text">{{((shopid=='1823'||shopid=='1882')&&(item.label=='日语版'||item.label=='英文版'))?'Free':(res.noReward!=1?'打赏':'免费')}}</div>
                </div>
                <!--右侧购买收听按钮-->
                <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index,'tjList')">详情</button>
                <button v-if="(item.buy==12)||(item.isuser)||(item.price==0&&res.noReward==1)" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'tjList')">收听</button>
                <button v-else-if="item.price==0" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'tjList','rewardShow')">打赏</button>
                <!--<button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index,'tjList')">{{shop.banner_top==1?'购买':'购买/激活'}}</button>-->
                <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index,'tjList')">购买</button>

              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="split-line h13"></div>

      <!--研学活动打卡胶囊-->
      <img v-if="res.isStudy==1&&res.studyUrl" class="activity-btn" @click="studyActivity" src="../../assets/activity-btn.png" alt="">

      <!--视频专辑-->
      <div class="video-con border-box" v-if="videoList.length>0">
        <div class="video-vr-tit border-box">短视频
          <p class="fr" v-if="videoTotal>1" @click="goVideoList(videoList[0].id,0)">查看更多</p>
        </div>
        <div class="video-con-box">
          <ul class="video-con-list clearfix">
            <li v-for="(item,index) in videoList" :key="item.id" v-if='index<3' @click="goVideoList(item.id,index)">
              <img class="img" v-lazy="item.headimg" alt="">
              <img class="icon" src="../../assets/view-video-bf.png" alt="">
              <p class="video-con-name border-box">{{item.title}}</p>
            </li>
            <li class="last" @click="goVideoList(videoList[0].id,0)">
              <img class="img" src="../../assets/a_02.jpg" alt="">
              <p>查看全部<br/>+短视频+</p>
            </li>
          </ul>
        </div>
        <div class="split-line h13"></div>
      </div>

      <!--新增VR真人讲解模块（跟音频一样的样式）-->
      <div class="video-vr border-box video-vr1" v-if="VRlist.length>0&&shop.vr2bag==1">
        <div class="video-vr-tit">VR真人讲解
          <router-link class="fr none" v-if="VRtotal>3" :to="{path:'/video-vrlist',query: {shopid:shopid,spotid:spotid,TimeStamp:TimeStamp,appKey:appKeyA}}">查看更多</router-link>
        </div>
        <div class="list border-box">
          <div class="list-box box" v-for="(item,index) in VRlist" :key="index" @click="goVideoVR(item.id,item.label)">
            <div class="block list-img">
              <img class="icon-tx" v-lazy="item.headimg" alt="">
            </div>
            <div class="block flex list-info">
              <div class="list-name guide-name hide">{{item.fname}}
                <span v-if="item.guidetag">{{item.guidetag}}</span>
              </div>
              <div class="list-group hide">
                <span class="fl hide">{{item.name}}</span>
                <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
              </div>
              <!--标签-->
              <div class="mt6 clearfix">
                <div v-if="item.listencount>0" class="label-color">
                  <img src="../../assets/adot-5.png" alt="">
                  <span>{{item.listencount|initNumber}}次播放</span>
                </div>
                <div v-if="(item.dsnum>0&&item.buynum<=0)||(item.dsnum>0&&item.price<=0)" class="label-color">
                  <img src="../../assets/adot-3.png" alt="">
                  <span>{{item.dsnum|initNumber}}人打赏</span>
                </div>
                <div v-else-if="(item.buynum>0&&item.price>0) && noBuys.indexOf(shopid)<=-1" class="label-color">
                  <img src="../../assets/adot-3.png" alt="">
                  <span>{{item.buynum|initNumber1}}人购买</span>
                </div>
              </div>
              <div class="sees-num-block clearfix">
                <div class="label-color">
                  <img src="../../assets/adot-7.png" alt=""> 包含{{item.spotNum}}个讲解点
                </div>
              </div>
              <!--价格-->
              <div class="price-text-box clearfix">
                <div v-if="item.price!=0" class="price-text">
                  <div>{{item.price}}元</div>
                </div>
                <div v-else-if="item.price==0" class="price-text">{{((shopid=='1823'||shopid=='1882')&&(item.label=='日语版'||item.label=='英文版'))?'Free':(res.noReward!=1?'打赏':'免费')}}</div>
              </div>
              <!--右侧购买收听按钮-->
              <template v-if="shopid==1603 || shopid==1810">
              </template>
              <template v-else>
                <button class="btn buy-btn buy-btn1" @click.stop="goVideoVR(item.id,item.label)">详情</button>
                <button v-if="item.isbuy>0 || item.buy==12 || item.price<=0" class="btn buy-btn buy-btn2" @click.stop="goVideoVR(item.id,item.label)">观看</button>
                <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideoVr(item.id)">购买</button>
              </template>
            </div>
          </div>
        </div>
        <div class="split-line h13" v-if="tablist && tablist.length>0"></div>
      </div>
      <!--新增VR真人讲解模块（原本的VR样式）-->
      <div class="video-vr border-box" v-else-if="VRlist.length>0&&shop.vr2bag!=1">
        <div class="video-vr-tit">VR真人讲解
          <router-link class="fr none" v-if="VRtotal>3" :to="{path:'/video-vrlist',query: {shopid:shopid,spotid:spotid,TimeStamp:TimeStamp,appKey:appKeyA}}">查看更多</router-link>
        </div>
        <div class="video-vr-con">
          <div class="video-vr-top" @click="goVideoVR(VRlist[0].id,VRlist[0].label)">
            <div class="video-vr-img" id="video-vr-img" v-if="VRlist[0].vrimg&&VRlist[0].vrimg!=''&&VRlist[0].vrimg!=null"></div>
            <img class="video-vr-img" v-lazy="VRlist[0].tvideourl" alt="" v-else>
            <!--<img class="video-vr-img" v-lazy="VRlist[0].tvideourl" alt="">-->
            <span class="video-vr-mask" v-if="loadPSV"></span>
            <img class="video-vr-btn pause" src="../../assets/view-video-bf.png" alt="" v-if="loadPSV">
            <img class="icon_360" src="../../assets/icon_360.png" alt="">
            <div class="video-tit border-box hide">{{VRlist[0].name}}</div>
            <span class="video-vr-txt num">{{VRlist[0].listencount|initNumber}}次播放</span>
            <span class="video-vr-txt spot">{{VRlist[0].spotNum}}个讲解点</span>
          </div>
          <div class="video-vr-bot border-box" v-if="VRtotal==1">
            <img class="fl video-vr-guide" v-lazy="VRlist[0].headimg" alt="">
            <span class="fl video-vr-name hide">{{VRlist[0].fname}}</span>
            <button class="fr btn buy-btn buy-btn2" @click="goVideoVR(VRlist[0].id,VRlist[0].label)" v-if="VRlist[0].isbuy>0 || VRlist[0].price<=0">观看</button>
            <button class="fr btn buy-btn buy-btn2" @click="buyVideoVr(VRlist[0].id)" v-else>购买</button>
          </div>

          <div class="video-vr-top" @click="goVideoVR(VRlist[1].id,VRlist[1].label)" style="margin-top: .24rem" v-if="VRtotal>=2&&VRtotal%2==0">
            <img class="video-vr-img" v-lazy="VRlist[1].vrimg" alt="">
            <span class="video-vr-mask"></span>
            <img class="icon_360" src="../../assets/icon_360.png" alt="">
            <div class="video-tit border-box hide">{{VRlist[1].name}}</div>
            <span class="video-vr-txt num">{{VRlist[1].listencount|initNumber}}次播放</span>
            <span class="video-vr-txt spot">{{VRlist[1].spotNum}}个讲解点</span>
          </div>
        </div>
        <div class="video-vr-con video-vr-con1" v-if="VRtotal>2">
          <div class="video-vr-top" :class="((VRtotal%2==0&&index%2==0)||(VRtotal%2==1&&index%2==1))?'fl':'fr'" v-for="(item,index) in VRlist" :key="index" @click="goVideoVR(item.id,item.label)" v-if="((VRtotal%2==0&&index>1)||(VRtotal%2==1&&index>=1))">
            <img class="video-vr-img" v-lazy="item.vrimg" alt="">
            <span class="video-vr-mask" v-if="loadPSV"></span>
            <img class="icon_360" src="../../assets/icon_360.png" alt="">
            <div class="video-tit border-box hide">{{item.name}}</div>
            <span class="video-vr-txt num">{{item.listencount|initNumber}}次播放</span>
            <span class="video-vr-txt spot">{{item.spotNum}}个讲解点</span>
          </div>
        </div>
      </div>


      <!--郭沫若景区官方推荐在VR下面-->
      <div class="popularity-recommend" v-if="tlist.length>0&&shopid==1639">
        <div class="popularity-recommend-title border-box">官方推荐</div>
        <div class="list border-box">
          <div  v-for="(item,index) in tlist" :key="index">
            <div  class="list-box box list-boxVideo" @click="goVideoPlayView(index,'tjList')" v-if="item.bagtype==1">
              <!--左侧头像部分-->
              <div class="block list-img">
                <!--解说员头像-->
                <img class="icon-tx" v-lazy="item.tvideourl" alt="">
                <div class="listen-btn-num">
                  <img src="../../assets/icon_play_btn13.png" alt="">
                  <span  v-if="item.buy==12||item.price==0||item.isuser">观看</span>
                  <span  v-else>试看</span>
                </div>
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <!--语音名称-->
                <div class="list-name guide-name hide">{{item.name}}
                  <span v-if="item.label">{{item.label}}</span>
                </div>
                <div class="list-group hide">
                  <span class="fl hide">{{item.info}}</span>
                </div>
                <!--标签-->
                <div class="mt6 clearfix">
                  <div class="label-color">
                    <img src="../../assets/adot-5.png" alt="">
                    <span>1000+次播放</span>
                  </div>
                  <div  class="label-color" v-if="noBuys.indexOf(shopid)<=-1 && (item.buynum>0&&item.price>0)">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.buynum|initNumber1}}人购买</span>
                  </div>
                </div>
                <!--价格-->
                <div class="price-text-box clearfix">
                  <div v-if="item.price!=0" class="price-text">
                    <div>{{item.price}}元 <span class="sellprice" v-if="shop.showSellprice">{{item.price2}}元</span></div>
                  </div>
                  <div v-else class="price-text">
                    <div>免费 </div>
                  </div>
                </div>
                <!--右侧购买收听按钮-->
                <button v-if="(item.buy!=12)&&(!item.isuser)&&(item.price!=0) || (item.buy==12||item.isuser)" class="btn buy-btn buy-btn1" @click.stop="goVideoPlayView(index,'tjList')">详情</button>
                <button v-if="(item.buy==12)||(item.price==0)||(item.isuser)" class="btn buy-btn" @click.stop="goVideoPlayView(index,'tjList')">观看</button>
                <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo1(index,'tjList')" >购买</button>
              </div>
            </div>
            <div  class="list-box box" @click="goVideoPlay(index,'tjList')" v-if="item.bagtype==null ||item.bagtype==0 ">
              <!--左侧头像部分-->
              <div class="block list-img">
                <!--解说员头像-->
                <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
                <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">
                <!--头像底部语音播放 -->
                <div class="listen-btn-num" v-if="item.buy==12||item.price==0||item.isuser">
                  <img src="../../assets/icon-listen.png" alt="">
                  <span>收听</span>
                </div>
                <div class="listen-btn-num" @click.stop="listenTurlClick(index,'tjList')" v-else>
                  <img :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')" alt="">
                  <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
                </div>
              </div>
              <!--右侧语音内容部分-->
              <div class="block flex list-info">
                <!--语音名称-->
                <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
                  <span v-if="item.guidetag">{{item.guidetag}}</span>
                </div>
                <div class="list-group hide">
                  <span class="fl hide">{{item.name}}</span>
                  <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
                </div>
                <!--标签-->
                <div class="mt6 clearfix">
                  <div v-if="item.listen>0" class="label-color">
                    <img src="../../assets/adot-5.png" alt="">
                    <span>{{item.listen|initNumber}}人收听</span>
                  </div>
                  <div v-if="(item.dsnum>0&&item.buynum<=0&&res.noReward!=1)" class="label-color">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.dsnum|initNumber}}人打赏</span>
                  </div>
                  <div v-else-if="(item.buynum>0&&item.price>0) && noBuys.indexOf(shopid)<=-1" class="label-color">
                    <img src="../../assets/adot-3.png" alt="">
                    <span>{{item.buynum|initNumber1}}人购买</span>
                  </div>
                </div>
                <div class="sees-num-block clearfix">
                  <div class="label-color">
                    <img src="../../assets/adot-7.png" alt="">
                    <span>包含{{item.sees}}个讲解点</span>
                  </div>
                </div>
                <!--价格-->
                <div class="price-text-box clearfix">
                  <div v-if="item.price!=0" class="price-text">
                    <div>{{item.price}}元 <span class="sellprice" v-if="shop.showSellprice">{{item.price2}}元</span><span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
                  </div>
                  <div v-else-if="item.price==0" class="price-text">{{((shopid=='1823'||shopid=='1882')&&(item.label=='日语版'||item.label=='英文版'))?'Free':(res.noReward!=1?'打赏':'免费')}}</div>
                </div>
                <!--右侧购买收听按钮-->
                <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index,'tjList')">详情</button>
                <button v-if="(item.buy==12)||(item.isuser)||(item.price==0&&res.noReward==1)" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'tjList')">收听</button>
                <button v-else-if="item.price==0" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'tjList','rewardShow')">打赏</button>
                <!--<button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index,'tjList')">{{shop.banner_top==1?'购买':'购买/激活'}}</button>-->
                <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index,'tjList')" >购买</button>

              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="split-line h13" v-if="tlist.length>0&&shopid==1639"></div>

      <!--导游分类-->
      <div class="list-tab" v-if="tablist && tablist.length>0">
        <div v-for="(item,index) in tablist" :key="index" @click='tablistClick(item.id)' class="flex" :class="cid == item.id ? 'curr': ''">{{item.name}}</div>
      </div>
      <!--语音列表-->
      <div class="list border-box" :class="siteBrotherList.length>0?'brothers':''" v-if="bagList && bagList.length>0">
        <div v-for="(item,index) in bagList" :key="index">
          <div class="video-vr-tit title1" :class="'sty'+index" v-if="shop.vr2bag==2 && (index===0 || (index!==0 && item.teamName!=bagList[index-1].teamName))">{{item.teamName}}</div>
          <div class="list-box box" :class="shop.vr2bag==2?'vr2bag':''" @click="item.bagtype!=2?goVideoPlay(index,'bagList'):goVideoVR(item.id,item.label)">
            <!--左侧头像部分-->
            <div class="block list-img">
              <!--解说员头像-->
              <!--<img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="" @click.stop="goGuideInfo(item.id)">-->
              <img class="icon-tx" v-lazy="item.guideheadimg2?item.guideheadimg2:item.guideheadimg" alt="">

              <div v-if="item.bagtype!=2">
                <div class="listen-btn-num" v-if="item.buy==12||item.price==0||item.isuser">
                  <img src="../../assets/icon-listen.png" alt="">
                  <span>收听</span>
                </div>
                <div class="listen-btn-num" @click.stop="listenTurlClick(index,'bagList')" v-else>
                  <img :src="item.isplay==1?require('../../assets/icon_listen02.gif'):require('../../assets/icon-listen.png')" alt="">
                  <span>{{item.isplay==1?item.resTime+"'":"试听"}}</span>
                </div>
              </div>
              <div v-else>
                <div class="video-vr-mask"><img class="icon_360" src="../../assets/icon_360.png" alt=""></div>
              </div>
            </div>

            <!--右侧语音内容部分-->
            <div class="block flex list-info">
              <!--语音名称-->
              <div class="list-name guide-name hide">{{item.guidename2?item.guidename2:item.guidename}}
                <span v-if="item.guidetag">{{item.guidetag}}</span>
              </div>
              <div class="list-group hide">
                <span class="fl hide">{{item.name}}</span>
                <span v-if="item.label" class="label-color label-type">{{item.label}}</span>
              </div>
              <!--标签-->
              <div class="mt6 clearfix">
                <div v-if="item.listen>0" class="label-color">
                  <img src="../../assets/adot-5.png" alt="">
                  <span>{{item.listen|initNumber}}人{{shop.vr2bag!=2?'收听':'播放'}}</span>
                </div>

                <div v-if="(item.dsnum>0&&item.buynum<=0&&res.noReward!=1)||(item.dsnum>0&&item.price<=0&&res.noReward!=1)" class="label-color">
                  <img src="../../assets/adot-3.png" alt="">
                  <span>{{item.dsnum|initNumber}}人打赏</span>
                </div>
                <div v-else-if="(item.buynum>0&&item.price>0) && noBuys.indexOf(shopid)<=-1" class="label-color">
                  <img src="../../assets/adot-3.png" alt="">
                  <span>{{item.buynum|initNumber1}}人购买</span>
                </div>
              </div>
              <div class="sees-num-block clearfix">
                <div class="label-color">
                  <img src="../../assets/adot-7.png" alt=""> 包含{{item.sees}}个讲解点
                </div>
              </div>
              <!--价格-->
              <div class="price-text-box clearfix">
                <div v-if="item.price!=0 && noPrice.indexOf(shopid)<=-1" class="price-text">
                  <div>{{item.price}}元 <span class="sellprice" v-if="shop.showSellprice">{{item.price2}}元</span> <span class="sees-num-inline">(包含{{item.sees}}个讲解点)</span></div>
                </div>
                <div v-else-if="item.price==0" class="price-text">{{((shopid=='1823'||shopid=='1882')&&(item.label=='日语版'||item.label=='英文版'))?'Free':(res.noReward!=1?'打赏':'免费')}}</div>
              </div>
              <!--右侧购买收听按钮,云南省博物馆去掉购买按钮-->
              <div class="btn-group" v-if="shopid==1603 || shopid==1810">
                <template v-if="item.bagtype==2">
                  <button class="btn buy-btn buy-detail-btn1" @click.stop="goVideoVR(item.id,item.label)">详情</button>
                  <button v-if="item.isbuy>0 || item.buy==12 || item.price<=0" class="btn buy-btn buy-detail-btn2" @click.stop="goVideoVR(item.id,item.label)">观看</button>
                </template>
                <template v-else>
                  <button class="btn buy-btn buy-detail-btn1" @click.stop="goVideoPlay(index,'bagList')">详情</button>
                  <button v-if="(item.buy==12)||(item.isuser)||(item.price==0&&res.noReward==1)" class="btn buy-btn buy-detail-btn2" @click.stop="goVideoPlay(index,'bagList')">收听</button>
                  <button v-else-if="item.price==0" class="btn buy-btn buy-detail-btn2" @click.stop="goVideoPlay(index,'bagList','rewardShow')">打赏</button>
                </template>
              </div>
              <template v-else>
                <template v-if="item.bagtype==2">
                  <button class="btn buy-btn buy-btn1" @click.stop="goVideoVR(item.id,item.label)">详情</button>
                  <button v-if="item.isbuy>0 || item.buy==12 || item.price<=0" class="btn buy-btn buy-btn2" @click.stop="goVideoVR(item.id,item.label)">观看</button>
                  <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideoVr(item.id)">购买</button>
                </template>
                <template v-else>
                  <button class="btn buy-btn buy-btn1" @click.stop="goVideoPlay(index,'bagList')">详情</button>
                  <button v-if="(item.buy==12)||(item.isuser)||(item.price==0&&res.noReward==1)" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'bagList')">收听</button>
                  <button v-else-if="item.price==0" class="btn buy-btn buy-btn2" @click.stop="goVideoPlay(index,'bagList','rewardShow')">打赏</button>
                  <button v-else class="btn buy-btn buy-btn2" @click.stop="buyVideo(index,'bagList')" >购买</button>
                </template>
              </template>
            </div>
          </div>
        </div>


        <p class="load-tip" ref="loadtip">{{loadText}}</p>
      </div>

      <!--其他展馆-->
      <div v-if="siteBrotherList.length>0">
        <div class="split-line" style="height: .16rem;"></div>
        <p class="jc-tit border-box">其他关联{{siteBrotherName?siteBrotherName:'场馆'}}
          <router-link class="fr" v-if="siteBrotherList.length>1" :to="{path:'/view-detail-group',query: {shopid:shopid,siteid:siteid,sregion:sregion,TimeStamp:TimeStamp,appKey:appKeyA}}">{{siteBrotherTit}}
            <img src="../../assets/back.png" alt="">
          </router-link>
        </p>
        <ul class="zg-ul border-box clearfix">
          <li v-for="(item,index) in siteBrotherList" :key="index" @click="goViewDetail(item.id)" v-if="index<3">
            <img v-lazy="item.logo" alt="">
            <p class="hide">{{item.name}}</p>
          </li>
        </ul>
      </div>
    </div>

    <!--景区详情内容-->
    <div class="tab-scenic-box" :class="tabIntroCurr==2?'':'none'">
      <!--景区地址-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-title">景区地址</div>
        <div class="scenic-details-info mt13">{{shop.address}}</div>
      </div>

      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--门票及开放时间信息-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-title border-box">门票价格</div>
        <div class='scenic-details-info mt13'>{{shop.special=='0'?'免费':(shop.special+'元')}}</div>
        <div class="split-line" style="height: 1px;margin:.26rem 0;background: #f0f0f0;"></div>
        <div class="scenic-details-title">门票信息</div>
        <div class="scenic-details-info mt13" v-if="(shop.specialinfo=='')||(shop.specialinfo==null)||(!shop.specialinfo)">暂无信息</div>
        <div class="scenic-details-info mt13" v-html="shop.specialinfo" v-else></div>
        <div class="split-line" style="height: 1px;margin:.26rem 0;background: #f0f0f0;"></div>
        <div class="scenic-details-title border-box">开放时间</div>
        <div class="scenic-details-info mt13">{{(shop.linestime+shop.lineetime)=='00:0000:00'?'全天':(shop.linestime+'-'+shop.lineetime)}}</div>
      </div>

      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--景区信息-->
      <div class="scenic-padding scenic-details-box border-box">
        <div class="scenic-details border-box">
          <div class="scenic-details-title border-box">景区信息</div>
          <!--<div class="scenic-details-info mt13">{{(shop.info=='')||(shop.info==null)||(!shop.info)?'暂无景区信息':shop.info}}</div>-->
          <div class="scenic-details-info mt13" v-if="(shop.info=='')||(shop.info==null)||(!shop.info)">暂无景区信息</div>
          <div class="scenic-details-info mt13" v-html="shop.info" v-else></div>
          <div class="scenic-details-title border-box mt26">游玩路线</div>
          <div class="scenic-details-info mt13" v-if="shopid==1391">
            <p>&nbsp; &nbsp; &nbsp; &nbsp;半日游线路一（游玩时长约3小时）：双龙景区游客中心——毛泽东主席视察双龙电站纪念馆——双龙溪峡谷——双龙洞、冰壶洞——金华山非遗体验馆——返程。</p>
            <p>&nbsp; &nbsp; &nbsp; &nbsp;半日游线路二（游玩时长约3-4小时）：双龙景区游客中心——双龙洞、冰壶洞——金华山非遗体验馆——仙瀑洞——鹿女湖——返程。</p>
            <p>&nbsp; &nbsp; &nbsp; &nbsp;一日游线路（游玩时长约5-6小时）：双龙景区游客中心——毛泽东主席视察双龙电站纪念馆——双龙溪峡谷——双龙洞、冰壶洞——金华山非遗体验馆——仙瀑洞——朝真洞——鹿女湖——返程。</p>
          </div>
          <div class="scenic-details-info mt13" v-else>{{(routes=='')||(routes==null)||(!routes)?'暂无信息':routes}}</div>
        </div>
      </div>

      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--景区助手-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-title">景区助手</div>
        <div class="scenic-details-info mt13" v-if="shopid==1391">{{(shop.routetime=='')||(shop.routetime==null)||(!shop.routetime)?'暂无信息':shop.routetime}}</div>
        <div class="scenic-details-info mt13" v-else>建议游玩时长 {{(shop.routetime=='')||(shop.routetime==null)||(!shop.routetime)?'暂无信息':shop.routetime}}</div>
      </div>

    </div>

    <!--讲解导览-->
    <div class="tab-map-box" :class="tabIntroCurr==6?'':'none'">
      <div v-html="tourInfo" @click="tourInfoClick"></div>
    </div>

    <!--讲解点目录-->
    <div class="alert-box catalogue-box" :class="catalogueCurr==1?'curr':''">
      <div @click="catalogueCurr=0" class="mask"></div>
      <div class="catalogue-item border-box">
        <div class="font34 cor3">讲解点目录</div>
        <div class="catalogue-line"></div>
        <form class="catalogue-input" v-on:submit.prevent="getCatalist(1)">
          <input class="border-box" :placeholder="shop.name +'（'+ catalogueRoot.length + '个讲解点）'" value="" v-model='inputValue'/>
          <img src="../../assets/icon-search.png" alt="" @click='getCatalist(1)'>
        </form>
        <div class="catalogue-item-con border-box">
          <router-link v-for="(item,index) in catalogueRoot" :key="index" class="catalogue-name hide" @click.native='catalogueCurr=0':to="{path:'/spot-detail',query: {code:code,spotid:item.id,shopid:shopid,siteid:siteid,sregion:sregion,TimeStamp: TimeStamp, appKey: appKeyA}}">{{item.name}}</router-link>
        </div>
      </div>
    </div>
    <!--云南省博物馆定制样式-->
    <div class="view-footer" v-if="(shopid==1603 || shopid==1810) && bagList.length && !(bagList[0].isbuy>0 || bagList[0].buy==12)" @click="buyVideoVr(bagList[0].id)">
      <div class="lf">
        <div class="price">
          <span>￥</span>
          <b>{{bagList[0].price}}</b>
        </div>
        <div class="txt">
          包含所有展厅VR真人讲解<br/>一次购买，
          <template v-if="shopid==1603">
            有效期60天
          </template>
          <template v-if="shopid==1810">
            长期有效
          </template>
        </div>

      </div>
      <div class="rt">
        立即购买
      </div>
    </div>
    <!--试听结束弹窗新版-->
    <AlertListenEnd :spotbuy="shop.spotbuy"  :bag="bag" :couponid="couponid" :extral="extral" :shopid="shopid" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--红包活动弹窗(国庆节日红包)-->
    <AlertRedEnvelope  :redEnvelopes="redEnvelopes" @close="closeEnvelope" v-if="Object.keys(redEnvelopes).length>0"></AlertRedEnvelope>
    <!--红包活动弹窗(攀枝花类型的普通红包)-->
    <AlertRedEnvelNew  :redEnvelNew="redEnvelNew" @close="closeEnvelope" v-if="Object.keys(redEnvelNew).length>0"></AlertRedEnvelNew>

    <!--红包人物-->
    <AlertPersonEnvelope  :shopid="shopid" :personEnvelopes="personEnvelopes" @close="closeEnvelope" v-if="Object.keys(personEnvelopes).length>0"></AlertPersonEnvelope>

    <!--人物推荐+视频推荐(userTui=2)-->
    <AlertRecommendPerson :userTui="userTui" :shopid="shopid" :recommendPerson="recommendPerson" @close="closeEnvelope" v-if="recommendPerson"></AlertRecommendPerson>
    <!--新年人物推荐-->
    <AlertYearPerson  :shopid="shopid" :recommendYear="recommendYear" @close="closeEnvelope" v-if="recommendYear"></AlertYearPerson>


    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="0" v-if="buyTip==1"></AlertPayTip>

    <!--自定义富文本弹窗-->
    <AlertRichTxtTip @close="closeRichTxtTip" :comeForm="0" :shopname="shop.name" :richTxt="richTxt"  v-if="richTxt"></AlertRichTxtTip>

    <!--海报弹窗-->
    <AlertPoster  :id="shopid" :type="'shop'" @close="closePoster" v-if="posterShow==1"></AlertPoster>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--关注公众号弹窗-->
    <Focus :focusRes="focusRes" v-on:alert-Focus="closeFocus()" v-if="focusEwmShow==1"></Focus>


    <div class="vr-poster" v-if="vrPster==1 && res.iscover==1"  @click="VRPosterClose">
      <div v-html="coverinfo"></div>
      <!--<img class="bj" src="../../assets/ar/vr-poster.jpg" alt="" style="display:block;position:relative;width: 100%;height: 100%;object-fit: fill;">-->
      <!--<img class="theme" src="../../assets/ar/vr-dazu.png" alt="" style="display:block;position:absolute;width: auto; height: 89vh; left: 50%;top: -1%;z-index: 1;transform: translateX(-50%);">-->
      <!--<a class="txt" href="tel:18602833090" style="display:block;position:absolute;width: 100%;left: 0;right: 0;bottom: 10%;z-index: 1;line-height: .32rem;font-size: .24rem;color: #c29959;text-align: center;">-->
        <!--<img src="../../assets/ar/vr-tel.png" alt="" style="display: inline-block; width: .32rem;height: .32rem;vertical-align: sub;"> 联系客服 18602833090-->
      <!--</a>-->
    </div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import {getViewDetail, getBagTab, getCatalogue, uploadScan, getEnvelope, getUserTui, uploadUserBrowse, getNotice,getViewVr,getVideoList,getRichTxt,siteBrother,ScanTip,userinfoLogin,getTourinfo,getCoverinfo} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder, getWxMini, htmlImgPreview} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertRedEnvelope from '../../components/AlertRedEnvelope'
  import AlertPersonEnvelope from '../../components/AlertPersonEnvelope'
  import AlertRecommendPerson from '../../components/AlertRecommendPerson'
  import AlertYearPerson from '../../components/AlertYearPerson'
  import AlertRedEnvelNew from '../../components/AlertRedEnvelNew'
  import AlertPayTip from '../../components/AlertPayTip'
  import AlertRichTxtTip from '../../components/AlertRichTxtTip'
  import AlertPoster from '../../components/AlertPoster'
  import Focus from '../../components/Focus'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        isback: this.$route.query.isback || '', //是否显示返回按钮
        isxj: this.$route.query.isxj || '', //新疆扫码的不弹关注弹窗 1表示不弹
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        shopid: '', //景区id
        spotid: '', //景点id
        userInfo: {}, //用户信息
        inputValue: '',//搜索关键词
        page: 1,
        rows: 10,
        loadText: "数据加载中",
        res: "", //全部数据
        cid: "", //导游筛选
        bagList: [],//解说列表
        total: 0,//解说总数
        banners: [], //banner图片或者video
        shop: '',//景区信息
        routes: '',//游玩路线
        mylist: [], //我的购买
        tlist: [],//推荐列表
        tablist: [],//导游分类列表
        tabIntroCurr: 1,//语音、景区详情及目录切换
        catalogueCurr: 0,//目录弹窗
        catalogueRoot: [],//目录弹窗内容
        personEnvelopes: [], //红包人物
        redEnvelopes: [], //国庆红包数据
        redEnvelNew: [], //攀枝花类型的普通红包
        recommendPerson: '', //推荐人物专辑数据
        recommendYear: '', //推荐人物专辑数据+音频
        userTui: '', //推荐弹窗类型
        buyTip: 0, //购买提醒弹窗
        richTxtTip: 1, //自定义富文本弹窗
        richTxt: '',//自定义弹窗内容

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        listType: '', //所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’
        lastListType: '', //记录上一次所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        posterShow: 0, //分享海报弹窗

        VRlist: [], //VR视频列表
        VRtotal: 0, //VR视频专辑总数
        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        focusRes:'',//二维码弹窗数据

        videoList: [], //视频列表
        videoTotal: 0, //视频专辑总数

        siteBrotherList: [], //关联的展区
        siteBrotherTit: '', //关联景区的查看更多标题
        siteBrotherName: '', //关联景区的左侧标题

        P400: 0, //系统维护中
        PSV: null, //全景图片
        loadPSV: false, //全景是否加载完
        m_res:'',//景区全部数据临时存储
        usernote: this.$route.query.usernote || '', //扫码得到的时间戳

        isWxMini: false, //返回是否是小程序环境
        noBuys: '907,1334,1828,264', //不显示购买量的景区shopid
        noPrice: '1603,1810', //不显示价格的景区

        vrPster: 0, //开机广告:大足石刻
        tourInfo: '',//导览详情
        coverinfo: '',//封面详情
      }
    },
    computed: {

    },
    created(){

      this.$loading.show('数据加载中');
      this.shopid = this.$route.query.shopid;
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }
      this.getTablist();
      this.getCatalist();
      this.getVideoList();
      this.siteBrother();

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      let self = this;
      if(this.qrcode){
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
        this.getCoverinfoFun();
      }

      //红包活动
      if(this.shopid!=69 || (this.shopid==69&&this.qid==134)){
        this.getActivity();
      }
      if(this.shopid!=1609){
        this.getBuyNotice();
      }

      if(!this.isxj){
        this.getRichTxt();
      }

      if(this.usernote){
        this.getScanTip();
      }

      getWxMini(function(res){
        self.isWxMini =  res;
        console.log(self.isWxMini)
      });

      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun);
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        if(this.bagList.length>0){
          this.bagList[this.index1].isplay = 0;
        }
        if(this.tlist.length>0){
          this.tlist[this.index1].isplay = 0;
        }

        this.bag = {};
      }
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        this.page = page;
        let res = await getViewDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: page,
          rows: this.rows,
          shopid: this.shopid,
          cid: this.cid,
          usernote: this.usernote || ''
        });

        if (res.errcode === "00000"){
          this.$loading.hide();
          this.m_res = res;
          this.res = res.data;
          this.shop = res.data.shop;
          this.$route.meta.title = this.shop.name;
          this.mylist = res.data.mylist;
          if(this.qrcode && res.data.isturn && res.data.mylist.length>0){
            if(this.shop.spotbuy==1){
              this.$router.push({
                path: `/video-play-py?${'id='+this.mylist[0].id+'&spotid='+this.mylist[0].spotid+'&shopid='+this.shopid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
              });
            }else {
              this.$router.push({
                path: `/video-play?${'id='+this.mylist[0].id+'&spotid='+this.mylist[0].spotid+'&shopid='+this.shopid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
              });
            }
          }
          if(this.qrcod && res.data.mylist.length<=0){
            this.vrPster = 1;
          }

          this.focusRes = res.data;
          this.banners = res.data.bannerinfo;
          this.routes = res.data.routes;
          for(var i=0; i<res.data.tlist.length; i++){
            res.data.tlist[i].isplay = 0;
            res.data.tlist[i].toaTime = '';
            res.data.tlist[i].resTime = '';
          }
          this.tlist = res.data.tlist;

          this.loadMyBaseData(res,1)//1基础数据加载  2 vr数据加载

          if(this.res.istour){
            this.getTourinfoFun()
          }

          var share = res.data.share;
          let link = '/view-detail?shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.shop.name;
            let desc = '历史会说话！金牌解说为您讲解' + this.shop.name + '的历史故事';
            let img = this.banners[0].img;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }
        }else if(res.errcode == "40002"){
          this.userinfoLoginFun()
        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },

      //重新上传用户信息
      async userinfoLoginFun(){
        var user = getStore("userInfo");
        let res = await userinfoLogin({
          openid: user.openid,
          avatarUrl: user.headimg || user.headimgurl || 'https://filewc.geeker.com.cn/jpjs/upload/default/girl.jpg',
          nickname: user.nickname || user.name || '匿名用户',
          city: user.city || '',
          gender: user.sex,
          encryptedData: '',
          iv: ''
        });
        if(res.errcode === "00000"){
          location.reload();
          this.$router.go(0);
        }else {
          this.$alert({
            title: '提示',
            content: res.errmsg
          });
        }
      },

      loadMyBaseData(res,m_type){
        var total = res.data.total;
        for(var i=0; i<res.data.root.length; i++){
          res.data.root[i].isplay = 0;
          res.data.root[i].toaTime = '';
          res.data.root[i].resTime = '';
        }

        let bagList = res.data.root;
        if (this.page >= Math.ceil(total / this.rows) || bagList.length >=total) {
          this.loadText = '已经到底了'
        } else {
          this.loadText = '加载更多'
        }
        if (bagList.length > 0) {
          this.bagList = [...this.bagList, ...bagList];
        } else {
          if (this.page == 1) {
            this.bagList = [];
            this.loadText = '暂无数据'
          } else {
            this.loadText = '已经到底了'
          }
        }
        if (m_type == 1 && this.page==1){
          this.getVr();
        }
      },

      //获取VR数据
      async getVr(){
        let res = await getViewVr({
          TimeStamp: this.TimeStamp,
      openid: this.userInfo.openid,
      shopid: this.shopid,
      spotid: this.spotid || '',
      page:1,
      rows:50
        });
        if(res.errcode == '00000'){
          if(res.data.root != null && res.data.root.length > 0){
            if (this.shop.vr2bag == 2){
              this.m_res.data.root = res.data.root;
              this.m_res.data.total = res.data.total;
              this.loadMyBaseData(this.m_res,2);
            }else {
              this.VRlist = res.data.root;
              this.VRtotal = res.data.total;

              var self = this;
              self.$nextTick(function(){
                if(self.VRlist[0].vrimg && self.VRlist[0].vrimg != '' && self.VRlist[0].vrimg != null && (self.shopid!=852) && self.shop.vr2bag!=1){
                  self.showPhotoVR(self.VRlist[0].vrimg,'video-vr-img');
                }
              })
            }

          }
        }
      },

      //获取视频数据
      async getVideoList(){
        let res = await getVideoList({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          shopid: this.shopid,
          orderby: 'tui',
        });
        if(res.errcode == '00000'){
          if(res.data.data != null && res.data.data.length > 0){
            this.videoList = res.data.data;
            this.videoTotal = res.data.total;

          }
        }
      },

      //获取导览图
      async getTourinfoFun(){
        let res = await getTourinfo({
          shopid: this.shopid,
          spotid: this.spotid || '',
        });
        if(res.errcode == '00000' && res.data){
          this.tourInfo = res.data.tour;
        }
      },
      //获取封面详情
      async getCoverinfoFun(){
        let res = await getCoverinfo({
          shopid: this.shopid,
          spotid: this.spotid || '',
        });
        if(res.errcode == '00000' && res.data){
          this.coverinfo = res.data.cover
        }
      },

      //获取相关联的展馆数据
      async siteBrother(){
        let res = await siteBrother({
          TimeStamp: this.TimeStamp,
          id: this.shopid
        });
        if(res.errcode == '00000'){
          if(res.data && res.data.root && res.data.root.length > 0){
            this.siteBrotherName = res.data.bro_title;
            this.siteBrotherList = res.data.root;
            this.siteBrotherTit = res.data.more;
          }
        }
      },

      handleFun: function (){
        let self = this;
        self.$nextTick(function() {
          if(self.tabIntroCurr == "1" && self.bagList.length>0){
            loadMore(self,function(page){
              self.initData(page);
            });
          }
        })
      },

      //获取红包活动数据
      async getActivity(){
        let res1 = await getEnvelope({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid,
          type: 0,
          shopId: this.shopid
        });

        if (res1.errcode == '00000' && res1.errmsg == 'SUCCESS' && res1.data.length > 0) {
          if(res1.data[0].model == 1){ //红包活动弹窗（攀枝花类型的普通红包）
            res1.data[0].takeEnvelope = 0;
            this.redEnvelNew = res1.data[0].coupon;
          }else if(res1.data[0].model == 2){
            this.$toast('红包已领取成功')
          }else {   //红包活动弹窗（国庆红包数据）
            res1.data[0].takeEnvelope = 0;
            this.redEnvelopes = res1.data[0];
          }
        } else {
          //配置活动
          let res2 = await getUserTui({
            TimeStamp: this.TimeStamp,
            openid: this.userInfo.openid,
            shopid: this.shopid
          });
          if (res2.errcode == '00000' && res2.data != null) {
            if(res2.data.type == 1){ //推荐音频
              this.recommendYear = res2.data;
            }else if(res2.data.type == 0 || res2.data.type == 2){ //推荐图片 + 推荐视频
              this.userTui = res2.data.type;
              this.recommendPerson = res2.data;
            }
          }

        }

      },

      //提醒用户重新扫码弹窗
      async getScanTip(){
        let res = await ScanTip({
          id: this.shopid,
          usernote: this.usernote,
          openid: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.$alert({
            title: '温馨提示',
            content: '如您使用时退出了页面，可在景区内重新扫码进入',
            btnText: '知道了'
          });
        }
      },

      //提醒用户购买弹窗
      async getBuyNotice(){
        let res = await getNotice({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid,
          shopId: this.shopid
        });
        if (res.errcode === "00000"){
          this.buyTip = 1;
        }
      },

      //自定义弹窗
      async getRichTxt(){
        let res = await getRichTxt({
          TimeStamp: this.TimeStamp,
          shopid: this.shopid,
          openid: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          console.log(res)
          this.richTxt = res.data.smallcontent;
        }
      },

      //上传扫码数据
      async sendScan(lat,lng){
        let res = await uploadScan({
          openid: this.userInfo.openid,
          shopid: this.shopid,
          qid: this.qid || "",
          lat: lat || "",
          lng: lng || ""
        });
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //请求导游分类
      async getTablist(){
        let res = await getBagTab({
          TimeStamp: this.TimeStamp,
          openid:  this.userInfo.openid,
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.tablist = res.data.root;

          if(this.tablist && this.tablist.length>0){
            this.cid = this.tablist[0].id;
          }
          this.initData(this.page);
        }
      },

      //请求讲解点目录
      async getCatalist(type){
//        this.inputValue = this.inputValue.replace(/(^\s*)|(\s*$)/g, "");
        if(type==1 && this.inputValue === ' '){
          this.$toast('请输入搜索关键词');
          return false;
        }else if(type==1 && (this.inputValue.indexOf('%')>-1 || this.inputValue.indexOf('_')>-1)){
          this.$toast('关键词不能包含特殊字符');
          return false;
        }

        let res = await getCatalogue({
          TimeStamp: this.TimeStamp,
          type: 0,
          id: this.shopid,
          name: this.inputValue
        });
        if (res.errcode === "00000"){
          this.catalogueRoot = res.data.root
        }
      },

      //导游分类列表切换
      tablistClick(cid){
        MtaH5.clickStat("view_detail_tab");
        if(this.videoTimer != null){
          this.Audio.pause();
          clearInterval(this.videoTimer);
        }
        this.currIndex = -1;
        for(var i=0; i<this.bagList.length; i++){
          this.bagList[i].isplay = 0;
        }
        this.bag = {};

        this.$loading.show('数据加载中');
        this.loadText = '数据加载中'
        this.page = 1;
        this.bagList = [];
        this.cid = cid;

        this.initData(this.page);
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind,listType){
        MtaH5.clickStat('view_detail_listen');
        MtaH5.clickStat('xiangqingyeshit',{'viewdetaillisten':'true'});//景区、景点》1试听弹窗》购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'1listen':'true'});//景区景点1试听》直接购买》支付
        this.lastListType = this.listType;
        this.listType = listType;

        if(listType == 'tjList'){
          listenTurl(this,ind,this.tlist)
        }else {
          listenTurl(this,ind,this.bagList)
        }

      },

      //点击VR购买，调用下订单公用方法
      buyVideoVr(id){
        let self = this;
        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
        });
      },

      //点击购买，调用下订单公用方法
      buyVideo(ind,listType){
        MtaH5.clickStat("view_detail_buy");
        MtaH5.clickStat('zhuanjixiangqin',{'choose':'true'});//专辑详情页点击推荐景区》1购买》支付
        MtaH5.clickStat('viewspotbuy',{'1viewspotbuy':'true'});//景区景点直接点击1购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'2buy':'true'});//景区景点试听》1直接购买》支付
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;

        setStore("source", {"source": "index"})
        setStore("couponid", {"couponid": ""});
        if(self.shop.spotbuy==1){
          self.$router.push({
            path: `/pay-py?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&appKey='+(self.appKey)}`
          });
        }else {
          self.$router.push({
            path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=0'+'&appKey='+(self.appKey)}`
          });
        }
      },

      buyVideo1(ind,listType){  //视频购买
        MtaH5.clickStat("view_detail_buy");
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=1'+'&appKey='+(self.appKey)}`
        });

      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          if(this.listType == 'tjList'){
            this.tlist[this.index1].buy = 12;
          }else {
            this.bagList[this.index1].buy = 12;
          }
        }
      },

      //关闭活动弹窗
      closeEnvelope(msg){
        this.redEnvelopes = msg.redEnvelopes;
        this.personEnvelopes = msg.personEnvelopes;
        this.recommendPerson = msg.recommendPerson;
        this.recommendYear = msg.recommendYear;
        if(msg.redEnvelNew1){
          this.redEnvelNew = [];
          if(msg.type == 0){
            this.$toast('领取成功，购买专辑立减哟');
          }
        }
      },

      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },
      //
      closeRichTxtTip(msg){
        this.richTxt = msg;
      },

      //跳转到专辑详情页
      goVideoPlay(ind,listType,rewardShow){
        MtaH5.clickStat('jingqujingdiana-2',{'1tovideo':'true'});//景区景点1进入专辑详情》点击购买》支付
        MtaH5.clickStat('jingqujingdiana-3',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》购买》支付
        MtaH5.clickStat('jingqujingdiana-4',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》弹窗购买》支付

        this.listType = listType;
        let list = [];
        if(this.listType == 'myList'){
          list = this.mylist;
        }else if(this.listType == 'tjList'){
          list = this.tlist;
        }else {
          list = this.bagList;
        }

        if(rewardShow){
          if(this.shop.spotbuy==1){
            this.$router.push({
              path: `/video-play-py?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
            });
          }else {
            this.$router.push({
              path: `/video-play?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
            });
          }

        }else {
          if((list[ind].buy!=12)&&(!list[ind].isuser)){
            MtaH5.clickStat('list_detail_button')
          }
          if(this.shop.spotbuy==1){
            this.$router.push({
              path: `/video-play-py?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
            });
          }else {
            this.$router.push({
              path: `/video-play?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
            });
          }

        }
      },

      //跳转到VR视频
      goVideoVR(id,label){
        if(label=='turn'){
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2&label=turn'}`
          });
        }else {
          this.$router.push({
            path: `/video-vr?${'id='+id+'&shopid='+this.shopid+'&spotid='+this.spotid+'&isback=1&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=2'}`
          });
        }
      },

      //跳转到景区视频
      goVideoPlayView(ind){
        this.$router.push({
          path: `/video-play1?${'id='+this.tlist[ind].id+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=1'}`
        });
      },

      //跳转到景区页面
      goViewDetail(id){
//        this.$router.push({
//          path: `/view-detail?${'shopid='+ id +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
//        });
        this.$loading.show('数据加载中');

        this.shopid = id;
        this.loadText = '数据加载中';
        this.page = 1;
        this.bagList = [];
        this.cid = '';
        this.catalogueRoot = [];
        this.catalogueCurr = 0;
        this.tablist = [];
        this.siteBrotherList = [];
        this.videoList = [];
        this.videoTotal = 0;
        this.VRlist = [];
        this.VRtotal = 0;


        this.getTablist();
        this.getCatalist();
        this.getVideoList();
        this.siteBrother();
      },

      //跳转到导游详情页
      goGuideInfo(id){
        MtaH5.clickStat("view_detail_person");
        MtaH5.clickStat('jingqujingdiana',{'1guide':'true'});//景区景点1点击导游头像》个人主页购买》支付
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //跳转到首页
      goHome(){
        if(this.code){
          this.$router.push({
            path: `/city-site?${'code='+ this.code + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }else if(this.res.domain){
          window.location = this.res.domain
        }else {
          MtaH5.clickStat("view_to_home");//景区详情页面点击跳转首页
          this.$router.push({
            path: `/?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
          });
        }
      },

      //显示分享海报弹窗
      showPoster(){
        MtaH5.clickStat('poster_share',{'viewdetail':'true'});
        this.posterShow = 1;
      },

      //关闭分享海报弹窗
      closePoster(msg){
        this.posterShow = msg;
      },

      //景区介绍
      tabIntroCurr2(){
        this.tabIntroCurr = 2;
        MtaH5.clickStat('view_detail');
      },

      //讲解点目录
      catalogueCurr1(){
        this.catalogueCurr = 1;
        MtaH5.clickStat("catalogue");
      },

      //关注公众号
      focusFun(){
        MtaH5.clickStat("focus");//关注公众号
        this.focusEwmShow = 1;
      },

      //公众号弹窗关闭
      closeFocus(){
        this.focusEwmShow = 0;
      },

      //跳转到地图界面
      toMap(){
        this.$router.push({
          path: `/map?${'siteid='+ this.siteid + '&sregion='+ this.sregion + '&shopid='+ this.shopid + '&spotid='+ this.spotid + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //研学活动打卡胶囊跳转页面
      studyActivity(){
        window.location.href = this.res.studyUrl + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
      },

      showPhotoVR(imgurl,obj){
//        var imgurl = require('../../assets/qj.jpg');
        var self = this;
        console.log(imgurl)
        this.PSV = PhotoSphereViewer({
          container: obj,
          panorama: imgurl,
          autoload: true, //自动播放
          time_anim: 2000, //默认2000
          anim_speed: '2rpm', //默认2rpm
          navbar: false,  //不显示下面的导航栏
          overload: function(){
            self.loadPSV = true;
          }
        });
      },

      //跳转到视频专辑页面
      goVideoList(id,ind){
        this.$router.push({
          path: `/video-list?${'id='+id+'&ind='+ ind +'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&bagtype=4'}`
        });
      },

      //返回上一页
      back(){
        this.$router.go(-1);//返回上一层
      },

      VRPosterClose(){
        this.vrPster = 0
      },
      //富文本图片预览
      tourInfoClick(e){
        htmlImgPreview(e);
      },


  },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          let list = this.listType == 'tjList' ? this.tlist : this.bagList ;
          listenEndOrder(this,this.index1,list);
        }
      },
    },
    components: {
      Swiper,
      AlertListenEnd,
      AlertRedEnvelope,
      AlertPersonEnvelope,
      AlertRecommendPerson,
      AlertYearPerson,
      AlertRedEnvelNew,
      AlertPayTip,
      AlertRichTxtTip,
      AlertPoster,
      Focus,
      P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      },
      initNumber1: function (num) { //重置购买数据
        if(num>1000){
          num = '1000+'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  .page{ min-height: 98vh; overflow-x: hidden;}

  /*轮播图*/
  .swiper-con{width:100%;height: 3.85rem;}
  .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}
  .icon-share{position:absolute;top:.1rem;right:.12rem;width: .51rem;height: .51rem;padding:.10rem;z-index:2;}

  .list-box{border-bottom:1px solid #e6e6e6; }
  .popularity-recommend .list-box{border-bottom: none;}

  /*语音、详情、目录切换*/
  .tab-intro {position: relative;height:1.04rem;text-align:center;color:#3c403b;background:#fff;border-radius:.3rem .3rem 0 0;margin-top:-.23rem;z-index: 1;}
  .tab-intro img {display: block;width:.48rem;height:.48rem;margin:.16rem auto 0;}
  .tab-intro img.scenic-icon-curr{display: none;}
  .tab-intro span {margin-top:.06rem;font-size:.2rem;font-weight:bold;color: #3c403b;}
  .tab-intro .flex.curr .scenic-icon-curr {display: block;}
  .tab-intro .flex.curr .scenic-icon {display: none;}
  .tab-intro .flex.curr span {color: #fcba5a;}

  /*导游分类*/
  .list-tab {width: 100%;height:.82rem;line-height:.82rem;background:#fff;border-bottom:1px solid #f3f3f3;white-space:nowrap;overflow-x: auto;}
  .list-tab .flex {position:relative;display: inline-block;width:22%!important;height:.8rem;line-height:.8rem;text-align:center;font-size:.28rem;color:#666;  }
  .list-tab .flex.curr{color: #000;}
  .list-tab .flex.curr:after{content:'';position:absolute;bottom:0;left:50%;right:0;width:.24rem;height:.12rem;background:#f8ab39;border-radius: .12rem .12rem 0 0;transform: translateX(-50%);z-index:1;}
  .special .list-tab{display:-webkit-box;display:box;}
  .special .list-tab .flex{display:block;width:initial;-webkit-box-flex:1;box-flex:1;}

  /*官方推荐*/
  .popularity-recommend-title{width:100%;margin-top: .27rem;padding-left:.24rem;font-size:.3rem;color:#3d3d3d;font-weight:bold;}

  /*新版景区景点详情*/
  .scenic-padding{padding:.26rem .24rem;background:#fff;font-weight:bold;color:#555;}
  .scenic-details-box{position:relative;background: #fff;}
  .scenic-details-box.curr .scenic-details{height:auto;}
  .scenic-details-title{position:relative;font-size:.3rem;}
  .scenic-details-info{line-height:.4rem;font-size:.26rem;font-weight: normal;}

  /*VR真人讲解*/
  .video-vr{padding: 0 .26rem .4rem;}
  .video-vr-con{width: 100%;border-radius: .1rem;box-shadow: 0 0 .25rem #f7f7f7;overflow: hidden;}
  .video-vr-tit{width:100%;height: .96rem;font: bold .3rem/1.03rem "Microsoft YaHei";color: #3d3d3d;overflow: hidden;}
  .video-vr-tit .fr{font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .video-vr-top{ display: block; position:relative;width: 100%;height: 3rem;border-radius: .1rem .1rem 0 0;overflow: hidden;}
  .video-vr-img{position:absolute;top:0;left:0;width: 100%;height: 100%;border-radius: .1rem .1rem 0 0;object-fit: cover;}
  .video-vr-mask{position: absolute;z-index: 1;top:0;left: 0;width: 100%;height: 100%;background: rgba(0,0,0,.3);}
  .video-vr .icon_360{position: absolute;z-index: 1;top:.12rem;right:.12rem;width: 1.36rem;height: auto;}
  .video-vr .video-tit{position: relative;z-index: 1;width:100%;height:.75rem;padding: 0 1.6rem 0 .2rem;font: .26rem/.75rem "Microsoft YaHei";color: #fff;}
  .video-vr-btn{position: absolute;z-index:1;top:50%;left:50%;width: 1.02rem;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .video-vr-txt{position: absolute;z-index: 1;bottom: .14rem;font: bold .2rem "Microsoft YaHei";color: #fff;}
  .video-vr-txt.num{ left:.2rem;}
  .video-vr-txt.spot{ right:.2rem;}
  .video-vr-bot{position:relative;width:100%;height: .98rem;padding: 0 .2rem;}
  .video-vr-guide{width: .58rem;height: .58rem;margin-top:.2rem;border-radius: 50%;object-fit: cover;}
  .video-vr-name{max-width:70%;margin-left: .15rem;font: .26rem/.98rem "Microsoft YaHei";color: #000;}
  .video-vr-bot .buy-btn{top: 50%;transform: translateY(-50%);}

  .video-vr-con1 .video-vr-top{ margin-top: .24rem; width: 48.2%; }
  .video-vr-con1 .icon_360{ top: 42%; right: 50%; margin-right: -.68rem; }
  .video-vr1{ padding: 0 ;}
  .video-vr1 .video-vr-tit{width: auto; padding: .2rem .24rem 0; height: .36rem; line-height: .36rem; }
  .video-vr1 .video-vr-tit .fr{ line-height: .36rem; }
  .video-vr1 .list-box:last-child{ border-bottom: none; }


  /*轮播图内跳转首页按钮*/
  .link-btn{position: fixed;z-index:2;right:0;top: 2rem;height: .6rem;padding:0 .28rem;font: .28rem/.6rem "Microsoft YaHei";color:#fff;border-radius: .3rem 0 0 .3rem;background: rgba(0,0,0,.7);}
  .link-btn.link-back{top:inherit;bottom:30%;z-index: 21;}

  /*关注*/
  .focus{width:100%;height: .75rem;background: rgba(0,0,0,.8);color: #fff;}
  .icon-focus{float: left;width: auto;height: .52rem;margin:.115rem .22rem 0 .27rem; }
  .focus-txt{float: left;width:63%;font: .24rem/.75rem "Microsoft YaHei";letter-spacing: .02rem; }
  .focus-btn{float: right;width:1.15rem;height: .5rem;margin-top:.125rem;margin-right:.1rem;border: 1px solid #ffac56;color: #fff;font: .24rem/.5rem "Microsoft YaHei";color: #fff;
    text-align: center;border-radius: .3rem;-webkit-animation: focus 1.2s linear infinite;animation: focus 1.2s linear infinite;-webkit-transform: scale(.96);transform: scale(.96);}
  @-webkit-keyframes focus {
    0%{-webkit-transform: scale(.96);}
    20%{-webkit-transform: scale(1);}
    40%{-webkit-transform: scale(.96);}
    60%{-webkit-transform: scale(1);}
    80%{-webkit-transform: scale(.96);}
    100%{-webkit-transform: scale(1);}
  }
  @keyframes focus {
    0%{transform: scale(.96);}
    20%{transform: scale(1);}
    40%{transform: scale(.96);}
    60%{transform: scale(1);}
    80%{transform: scale(.96);}
    100%{transform: scale(1);}
  }

  .activity-btn{display: block;width: 98%;height: auto;margin: .2rem auto 0;}

  /*短视频*/
  .video-con .video-vr-tit{ padding: 0 .24rem; }
  .video-con-box{ padding: 0 0 .24rem .16rem; overflow-x: auto; }
  .video-con-list{ width: 8.32rem; padding-right: .24rem; }
  .video-con-list li{ position: relative; float: left; margin-left: .08rem; width: 2rem; height: 3rem; overflow: hidden; border-radius: .13rem; }
  .video-con-list li .icon{ position: absolute; left: 50%; top: 50%; width: .56rem; height: .56rem; transform: translate(-50%,-50%); }
  .video-con-name{ position: absolute; left: 0; right: 0; bottom: 0; z-index: 1; padding: 0 .12rem; height: .59rem; font-size: .2rem; line-height: .64rem; text-align: center; color: #fff; background: url(../../assets/a_01.png) repeat-x; }
  .video-con-list .last p{ position: absolute; left: 0; right: 0; top: 50%; font-size: .24rem; line-height: .34rem; text-align: center; color: #fff; transform: translateY(-50%);   }

  /*其他展馆*/
  .jc-tit{width: 100%;height: 1.12rem;padding:0 .3rem;font: bold .32rem/1.12rem "Microsoft YaHei";color: #3d3d3d;}
  .jc-tit .fr{ position: relative; padding-right: .25rem; font:normal .24rem/1.03rem "Microsoft YaHei";color: #555;}
  .jc-tit .fr img{ position: absolute; top: .4rem; right: 0; width: .13rem; height: auto; }
  .zg-ul{width: 100%;height: 2.44rem;padding: 0 .3rem;white-space: nowrap;overflow-x: auto;}
  .zg-ul li{position:relative;display:inline-block;width: 2.14rem;height: 100%;margin-right: .14rem;}
  .zg-ul li img{width: 100%;height: 1.68rem;border-radius: .08rem;object-fit: cover;}
  .zg-ul li p{margin-top: .12rem;font: .28rem/1.2 "Microsoft YaHei";color: #3d3d3d;text-align: center;}
  .brothers .list-box:last-of-type{ border-bottom: none; }
  .brothers .load-tip{ height: 0; padding: 0; overflow: hidden; }

  .price-text .sellprice{ font-size: .22rem; color: #999; text-decoration: line-through; }


  .video-vr-tit.title1{position: relative; margin-top: .4rem; padding-left: .2rem; font-size: .34rem; color: #333;overflow: visible; }
  .video-vr-tit.title1:after{position: absolute;left: -.24rem;top:-.13rem; right: -.24rem; content: ''; height: .13rem; background-color: #f6f9fa;}
  .video-vr-tit.sty0:after{height: 0;}
  .video-vr-tit.sty0{margin-top: 0;}
  .video-vr-tit.title1:before{position: absolute;left: 0;top:50%;content: ''; margin-top: -.18rem; width: .07rem; height: .36rem; background-color: #faaf39;}
  .list-box.vr2bag .video-vr-mask{position: absolute; z-index: 1; top: 64%; left: 5%; width: 90%; height: 25%; background: rgba(0,0,0,.5);border-radius: .3rem;}
  .list-box.vr2bag .icon_360{ position: absolute;z-index: 1;top:50%;left:50%;width: 86%;height: auto; transform: translate(-50%,-50%); }
  .list-box.vr2bag{border-bottom: none; }
  /*云南省博物馆样式*/
  .btn-group{position: relative;text-align: right;}
  .btn-group .buy-detail-btn1{width: 1.2rem;height: 0.53rem;line-height: .52rem;background: #fff;color: #faaf3a;border: 0.01rem solid #faaf3a;}
  .btn-group .buy-detail-btn2{width: 1.56rem;background: linear-gradient(to right, #fccd5b, #fdae33);}
  .btn-group .btn.buy-btn{position: relative;}
  .view-footer{position: fixed;display: flex;align-items: center;justify-content: center;left: 0;bottom: 0;width: 100%;height: 1.8rem;padding:0.3rem; background: #fff;box-shadow: 0 0 0.05rem #ddd;z-index: 999;box-sizing: border-box;}
  .view-footer .lf{display: flex;align-items: center;height: 100%;border-top-left-radius: 0.6rem;border-bottom-left-radius: 0.6rem; padding:0 0.3rem;color:#fff;background: #000;}
  .view-footer .rt{position:relative; flex:1;height: 100%;border-top-right-radius: 0.6rem;border-bottom-right-radius: 0.6rem;text-align: center;line-height: 1.2rem;font-weight: 900;font-size: 0.36rem; background:#fec200;}
  .view-footer .lf .price{margin-right:0.2rem;}
  .view-footer .lf .price span{font-size:0.28rem;}
  .view-footer .lf .price b{margin-left: -0.06rem;font-size:0.6rem;font-weight: bold;}
  .view-footer .lf .txt{font-size:0.24rem;}
  .view-footer .rt:before{position: absolute;content: '';left: 0;top: 0;width: 0;height: 0;border-top: 1.2rem solid #000000;border-right: 0.2rem solid transparent;border-left: 0px solid transparent;}
  .page{padding-bottom:1.4rem;}

  /*开机广告*/
  .vr-poster{position: fixed;left: 0;top: 0;right: 0;bottom: 0;z-index: 999;}
  /*.vr-poster .bj{display:block;position:relative;width: 100%;height: 100%;object-fit: fill;}*/
  /*.vr-poster .theme{display:block;position:absolute;width: auto; height: 89vh; left: 50%;top: -1%;z-index: 1;transform: translateX(-50%);}*/
  /*.vr-poster .txt{display:block;position:absolute;width: 100%;left: 0;right: 0;bottom: 10%;z-index: 1;line-height: .32rem;font-size: .24rem;color: #c29959;text-align: center;}*/
  /*.vr-poster .txt img{display: inline-block; width: .32rem;height: .32rem;vertical-align: sub;}*/
  /*讲解导览*/
  .tab-map-box{margin-top: .1rem;min-height: calc(100vh - 4.89rem);background-color: #ffebd0;}
  .tab-map-box > div{padding: .3rem .24rem .5rem;}

</style>
<style>
  .tab-map-box img{display: block;max-width: 100%;height: auto;margin: 0;}
</style>



// WEBPACK FOOTER //
// src/page/view-detail/view-detail.vue